export const selectLaraThemeConfig = {
  colorScheme: {
    light: {
      shadow: "none",
      background: "#FCFBFB",
      focus: {
        ring: {
          shadow: "none",
        },
        border: {
          color: "#4c4d4c",
        },
      },
      hover: {
        border: {
          color: "#4c4d4c",
        },
      },
    },
  },
};
